import { sha512 } from 'js-sha512';

import { LOGIN_SALT } from '../constants';

export function toUsername(email: string) {
  return email.toLowerCase().replace('@', '-at-');
}

export function hashPassword(password: string) {
  return sha512(password + LOGIN_SALT);
}
